import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Loader2, Radio as RadioIcon } from "lucide-react";
import api from "@/lib/api";
import { ContentCard } from "@/components/ContentCard";

export default function Radio() {
  const { t } = useTranslation();
  const [regions, setRegions] = useState([]);
  const [active, setActive] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/radio/regions").then(({ data }) => setRegions(data)); }, []);

  useEffect(() => {
    setLoading(true);
    api.get("/radio", { params: { region: active, limit: 150 } })
      .then(({ data }) => setItems(data.items)).finally(() => setLoading(false));
  }, [active]);

  return (
    <div className="pt-24 px-4 sm:px-8 lg:px-12 pb-20 min-h-screen" data-testid="radio-page">
      <div className="flex items-center gap-3 mb-2">
        <RadioIcon className="text-sky-400" size={28} />
        <h1 className="font-head text-3xl sm:text-4xl font-extrabold">{t("radio.title")}</h1>
      </div>
      <p className="text-zinc-400 mb-6">{t("radio.subtitle")}</p>

      <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-4 mb-4" data-testid="radio-region-filters">
        <button onClick={() => setActive("")} data-testid="radio-region-all"
          className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${active === "" ? "bg-sky-500 text-white" : "bg-white/10 text-zinc-300 hover:bg-white/20"}`}>
          {t("common.allStations")}
        </button>
        {regions.map((r) => (
          <button key={r.value} onClick={() => setActive(r.value)} data-testid={`radio-region-${r.value}`}
            className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${active === r.value ? "bg-sky-500 text-white" : "bg-white/10 text-zinc-300 hover:bg-white/20"}`}>
            {r.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid place-items-center py-20"><Loader2 className="animate-spin text-sky-400" size={36} /></div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {items.map((it) => <ContentCard key={it.id} item={it} />)}
        </div>
      )}
    </div>
  );
}
